import { useNavigate } from 'react-router-dom'
import { Home, ArrowLeft } from 'lucide-react'
import '../styles/NotFound.css';

export default function NotFound() {
  const navigate = useNavigate()

  return (
    <div className="page-container">
      <header className="page-header">
        <div className="container">
          <div className="text-xl font-bold" style={{ color: 'var(--color-primary)' }}>
            UltimaTag
          </div>
        </div>
      </header>
      
      <main className="page-main">
        <div className="container max-w-md text-center">
          <div className="card py-xl">
            <h1 className="text-6xl font-bold mb-md" style={{ color: 'var(--color-error)' }}>
              404
            </h1>
            <h2 className="text-2xl font-bold mb-md">Page non trouvée</h2>
            <p className="text-muted mb-lg">
              La page que vous cherchez n'existe pas ou a été déplacée.
            </p>
            <div className="flex flex-col sm:flex-row gap-sm justify-center">
              <button
                onClick={() => navigate(-1)}
                className="btn btn-outline"
              >
                <ArrowLeft size={20} />
                Retour
              </button>
              <button
                onClick={() => navigate('/')}
                className="btn btn-primary"
              >
                <Home size={20} />
                Page d'accueil
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}